import {getGraphNodesByInstanceIds} from "#graph/helpers/collect"
import type {NodeParameters} from "#graph/nodes/base/types"

export class GraphNodeSnapshot<
    BaseNode,
    Node extends {
        clone: (options?: {
            cloneSubNode?: (parent: BaseNode, subNode: BaseNode, path: string) => boolean
            parameterOverrides?: Partial<NodeParameters> | ((node: BaseNode) => NodeParameters | undefined)
            cloneInstanceIds?: boolean
        }) => Node
        instanceId: string
        [Symbol.iterator]: () => Iterator<Node, any, any>
    },
> {
    originalNodes: Map<string, Node>
    oldClone: Node
    oldClonedNodes: Map<string, Node>

    constructor(public node: Node) {
        this.originalNodes = getGraphNodesByInstanceIds<Node>(node)
        this.oldClone = node.clone({cloneSubNode: () => true, cloneInstanceIds: true})
        this.oldClonedNodes = getGraphNodesByInstanceIds<Node>(this.oldClone)
    }
}
